import { connect } from 'react-redux';
import { showDialog } from 'redux/duck/dialogDuck';
import {
  authLogoutRequested,
  authReadMyInformationRequested,
} from 'redux/duck/authDuck';
import App from 'component/base/App';

const mapStateToProps = (state, ownProps) => {
  return {
    someDialogOpenedState: state.dialogReducer.isSomethingOpen,
    authState: state.authReducer,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    // Dialog
    showDialog: (dialogKey, params, callback) => {
      dispatch(showDialog(dialogKey, params, callback));
    },
    // Auth
    logout: () => dispatch(authLogoutRequested()),
    readMeInfo: () => dispatch(authReadMyInformationRequested()),
  };
};

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(App);

export default AppContainer;
